if (!window.fetch) window.fetch = require('.').default || require('.');
